import Theme, { type ThemeMode } from '@/app/theme'
import { PreferencesProvider } from '@/app/state/preferences'
import { ConfigProvider, type AppConfigOverrides } from '@/app/config/context'

export type AppBootstrapProvidersProps = {
  children: React.ReactNode
  configOverrides?: AppConfigOverrides
  themeMode?: ThemeMode
  enableCssBaseline?: boolean
}

export default function AppBootstrapProviders({
  children,
  configOverrides,
  themeMode,
  enableCssBaseline,
}: AppBootstrapProvidersProps) {
  return (
    <ConfigProvider configOverrides={configOverrides}>
      <Theme mode={themeMode} enableCssBaseline={enableCssBaseline}>
        <PreferencesProvider>
          {children}
        </PreferencesProvider>
      </Theme>
    </ConfigProvider>
  )
}
